module.exports = __webpack_public_path__ + "static/media/digital_Health_Infographic.0980c741.pdf";